__webpack_require__.p = "https://script.vast.wtf/order-widget/downloads/latest/";